import { Dropdown, Layout, theme as antTheme } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineMenuFold, AiOutlineMenuUnfold } from "react-icons/ai";
import { FaRegUser } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { IoMdLogOut } from "react-icons/io";
import Avator from "../../../../assets/images/anonymous-avatar.jpg";
import LogoLarge from "../../../../assets/images/logo-new_taimuihongsg.png";
import LogoSmall from "../../../../assets/images/logo-mini-taimuihongsg.png";
import { clearUserLogin } from "../../../../redux/slices/user-slice";
import { clearUserFromCookies } from "../../../../utils/useStorage";

const HeaderAdmin = ({ collapsed, toggle }) => {
  const { device } = useSelector((state) => state.user);
  const token = antTheme.useToken();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onActionClick = async (action) => {
    switch (action) {
      case "userInfo":
        return;
      case "userSetting":
        return;
      case "logout":
        try {
          dispatch(clearUserLogin());
          localStorage.removeItem("userInfo");
          clearUserFromCookies();
          navigate("/admin/login");
        } catch (error) {
          console.log("Error in logout: ", error);
        }
        return;
      default:
        return;
    }
  };

  return (
    <Layout.Header
      style={{
        padding: 0,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        zIndex: 9,
        boxShadow: "0 4px 10px #dddddd",
        backgroundColor: token.token.colorBgContainer,
        position: "sticky",
        top: 0,
      }}
    >
      {device !== "MOBILE" ? (
        <div
          style={{
            width: collapsed ? 80 : 200,
            height: "100%",
          }}
        >
          <Link
            to="/admin"
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={collapsed ? LogoSmall : LogoLarge}
              style={{
                maxWidth: "100%",
                width: "auto",
                maxHeight: "100%",
                height: "auto",
                padding: "4px 6px",
              }}
              alt=""
            />
          </Link>
        </div>
      ) : (
        <div
          style={{
            width: collapsed ? 80 : 200,
            height: "100%",
          }}
        >
          <Link
            to="/admin"
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={LogoSmall}
              alt=""
              style={{
                maxWidth: "100%",
                width: "auto",
                maxHeight: "100%",
                height: "auto",
                padding: "4px 6px",
              }}
            />
          </Link>
        </div>
      )}
      <div
        style={{
          padding: "0 15px",
          flex: "1",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div onClick={toggle} style={{ cursor: "pointer" }}>
          <span>
            {collapsed ? (
              <AiOutlineMenuUnfold size={20} />
            ) : (
              <AiOutlineMenuFold size={20} />
            )}
          </span>
        </div>
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 32,
          }}
        >
          <Dropdown
            menu={{
              items: [
                {
                  key: "1",
                  icon: <FaRegUser />,
                  label: (
                    <span onClick={() => navigate("/admin/profile")}>
                      Tài khoản
                    </span>
                  ),
                },
                {
                  key: "2",
                  icon: <IoMdLogOut />,
                  label: (
                    <span onClick={() => onActionClick("logout")}>
                      Đăng xuất
                    </span>
                  ),
                },
              ],
            }}
          >
            <span
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <img
                src={Avator}
                alt="avator"
                style={{ marginRight: 8, width: 40, height: 40 }}
              />
            </span>
          </Dropdown>
        </div>
      </div>
    </Layout.Header>
  );
};

export default HeaderAdmin;
